module.exports = __webpack_public_path__ + "img/2bhk.0b9d79b5.png";